import { useState } from "react";
import OathboundNav from "@/components/OathboundNav/OathboundNav";
import PortalBackLink from "@/components/PortalBackLink";

const LORE_VAULT_BACKGROUND = "/media/images/lore_vault_bg.jpg";

function LoreCard({ item, isFlipped, onToggle }) {
  return (
    <button
      type="button"
      className={`lore-vault-card${isFlipped ? " is-flipped" : ""}`}
      onClick={() => onToggle(item.id)}
      aria-pressed={isFlipped}
      aria-label={`${isFlipped ? "Hide" : "Reveal"} lore for ${item.title}`}
      data-testid={`lore-vault-card-${item.id}`}
    >
      <span className="lore-vault-card-inner">
        <span className="lore-vault-card-face lore-vault-card-front">
          <span className="lore-vault-image-shell">
            <img
              src={item.image}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </span>
        </span>

        <span className="lore-vault-card-face lore-vault-card-back">
          <span className="lore-vault-card-title">{item.title}</span>
          <span className="lore-vault-card-description">
            {item.longDescription}
          </span>
        </span>
      </span>
    </button>
  );
}

const LoreVaultPage = ({ loreVaultData }) => {
  const [flippedCardId, setFlippedCardId] = useState(null);
  const items = loreVaultData?.items || [];

  const toggleCard = (id) => {
    setFlippedCardId((currentId) => (currentId === id ? null : id));
  };

  return (
    <main className="lore-vault-page" data-testid="lore-vault-page">
      <picture className="portal-background" aria-hidden="true">
        <img
          src={LORE_VAULT_BACKGROUND}
          alt=""
          width="1024"
          height="1024"
          decoding="async"
          fetchpriority="high"
        />
      </picture>
      <div className="lore-vault-vignette" aria-hidden="true" />

      <OathboundNav />

      <section className="lore-vault-shell" aria-labelledby="lore-vault-title">
        <PortalBackLink />

        <header className="lore-vault-header">
          <p className="lore-vault-eyebrow">{loreVaultData.eyebrow}</p>
          <h1 id="lore-vault-title">{loreVaultData.title}</h1>
          <p>{loreVaultData.intro}</p>
        </header>

        <div className="lore-vault-grid" aria-label="Lore vault entries">
          {items.map((item) => (
            <LoreCard
              key={item.id}
              item={item}
              isFlipped={flippedCardId === item.id}
              onToggle={toggleCard}
            />
          ))}
        </div>
      </section>
    </main>
  );
};

export default LoreVaultPage;
